const config = {
  apiBaseUrl: process.env.VUE_APP_OSIGU_API_BASE_URL || 'http://api.dev.osigu.sd:8080',
  getTokenMaxAttempts: process.env.VUE_APP_GET_TOKEN_MAX_ATTEMPTS || 5,
  getTokenAttemptDelayInSeconds: process.env.VUE_APP_GET_TOKEN_ATTEMPTS_DELAY_IN_SECONDS || 1,
  clientId: process.env.VUE_APP_CLIENT_ID || 'providers-web',
  clientSecret: process.env.VUE_APP_CLIENT_SECRET || 'e98150f9-0497-493d-86bd-7d7a83bf0ffb',
  intercomId: process.env.VUE_APP_INTERCOM_APP_ID || 'mvgu8g25',
  intercomKey: process.env.VUE_APP_INTERCOM_KEY || 'q0qFcEGh1_eWsiG0J3sGHp3Evwt_R7DUAQwfaiuC',
  theme: process.env.VUE_APP_THEME || 'GNP',
  fileSize: process.env.VUE_APP_FILE_SIZE || '10485760',
  eprescriptionWidgetUrl: process.env.VUE_APP_EPRESCRIPTION_WIDGET_URL || 'https://eprescription.widgets.osigu.com/development/53d43c9/widget.js',
  preAuthorizationWidgetUrl: process.env.VUE_APP_PREAUTHORIZATION_WIDGET_URL || 'https://preauthorization.widgets.osigu.com/development/160fe26/widget.js',
  userSiteUrl: process.env.VUE_APP_USER_SITE_URL || 'https://gnp-proveedores.dev.osigu.com/',
  beneficiaryId: process.env.VUE_APP_BENEFICIARY_ID || 0,
  providerOtpRetryInSeconds: process.env.VUE_RETRY_PROVIDER_OTP_IN_SECONDS || 30
}

export { config }
